export default "__VITE_ASSET__Bu0ck4JA__"